/**
 * La rutina acordada de Janeth (docs/Entrenamiento/ENTRENAMIENTO JANETH.md,
 * 23 oct 2026): lunes, miércoles y viernes, 30 a 40 minutos.
 *
 * Se ofrece en el teléfono que se eligió como de Janeth (rutinas-precargadas.ts)
 * y se crea cuando ella lo confirma: nada se crea solo.
 *
 * Decisiones de Janeth:
 * - Descansos (26 oct 2026): 2 min en todos los ejercicios. En las biseries,
 *   los 2 min van después de completar los dos; entre uno y otro no hay
 *   descanso. Si se hacen por separado, 2 min cada uno. Antes (23 oct) eran
 *   el máximo de cada rango: 120, 90 y 60 s, y 75 s en las biseries.
 * - Su curl femoral es acostado (23 oct 2026).
 * - Sin cargas iniciales: la primera vez dice "Primera vez".
 */

import type { EjercicioDePlantilla, RutinaDePlantilla } from './rutinas-precargadas';

/** Descanso confirmado de Janeth en el gimnasio (26 oct 2026). */
export const DESCANSO_DE_JANETH_SEG = 120;

export const GENERAL_DE_JANETH =
  'Calienta 4 a 5 minutos, con series ligeras de aproximación al primer ejercicio: no cuentan como series de trabajo. ' +
  'Termina cada serie con unas 2 repeticiones posibles con buena técnica (RIR 2). Primero sube repeticiones dentro del rango; ' +
  'al completar el máximo en todas las series, sube el menor incremento disponible. ' +
  'El tiempo de la sesión es una meta: no recortes un descanso que necesitas.';

const solo = (
  exerciseId: string,
  series: number,
  repsMin: number,
  repsMax: number,
  notas: string | null = null,
): EjercicioDePlantilla => ({
  exerciseId,
  series,
  repsMin,
  repsMax,
  descansoSeg: DESCANSO_DE_JANETH_SEG,
  biserie: null,
  descansoBiserieSeg: null,
  notas,
});

const enBiserie = (
  exerciseId: string,
  series: number,
  repsMin: number,
  repsMax: number,
  biserie: string,
  notas: string | null = null,
): EjercicioDePlantilla => ({
  exerciseId,
  series,
  repsMin,
  repsMax,
  descansoSeg: DESCANSO_DE_JANETH_SEG,
  biserie,
  descansoBiserieSeg: DESCANSO_DE_JANETH_SEG,
  notas,
});

export const RUTINA_DE_JANETH: readonly RutinaDePlantilla[] = [
  {
    id: 'janeth.lunes',
    nombre: 'Lunes · Glúteos y femorales',
    dias: [1],
    notas: GENERAL_DE_JANETH,
    ejercicios: [
      solo('ejb_peso_muerto_rumano_mancuernas', 3, 8, 10),
      solo('ejb_prensa', 3, 10, 12),
      enBiserie(
        'ejb_curl_femoral_acostado',
        2,
        10,
        15,
        'A',
        'Biserie con la máquina abductora: curl, después abductora, y descanso al terminar los dos. Si no se pueden ocupar las dos estaciones, hazlos por separado.',
      ),
      enBiserie('ejb_maquina_abductora', 2, 12, 20, 'A'),
    ],
  },
  {
    id: 'janeth.miercoles',
    nombre: 'Miércoles · Cuádriceps y torso',
    dias: [3],
    notas: GENERAL_DE_JANETH,
    ejercicios: [
      solo('ejb_prensa', 3, 8, 12),
      solo('ejb_extension_rodillas', 2, 10, 15),
      solo('ejb_remo_barra', 2, 10, 12),
      solo('ejb_press_inclinado_mancuernas', 2, 8, 12),
      solo(
        'ejb_crunch_banco_plano',
        2,
        10,
        15,
        'Boca arriba en banco plano, rodillas flexionadas y pies apoyados si caben con seguridad; brazos cruzados sobre el pecho. ' +
          'Acerca las costillas a la pelvis levantando solo la cabeza y la parte alta de los hombros, y baja con control. ' +
          'Sin sentarte por completo ni tomar impulso. Empieza sin peso; detente si molesta el cuello o la espalda.',
      ),
    ],
  },
  {
    id: 'janeth.viernes',
    nombre: 'Viernes · Glúteos y pierna',
    dias: [5],
    notas: GENERAL_DE_JANETH,
    ejercicios: [
      solo(
        'ejb_hip_thrust_barra',
        3,
        10,
        15,
        'Parte alta de la espalda en un banco firme que no se deslice. Es hip thrust con barra, no puente de glúteos en el suelo.',
      ),
      solo(
        'ejb_desplante_estatico',
        2,
        8,
        12,
        '8 a 12 por pierna. Un pie delante y otro detrás todas las repeticiones, sin juntar los pies; completa un lado y después el otro. Una serie incluye las dos piernas.',
      ),
      enBiserie(
        'ejb_curl_femoral_acostado',
        2,
        10,
        15,
        'A',
        'Biserie con el jalón al pecho si los aparatos están libres; si no, hazlos por separado. Descanso al terminar los dos.',
      ),
      enBiserie('ejb_jalon_pecho', 2, 10, 12, 'A'),
    ],
  },
];
